import { combine, createDomain, restore } from 'effector';
import { EditConfigLanguageType } from '@types';
import { getTemplateConfig } from '@utils/templateConfig';
import { $templateId, $tourData } from './dataStores';

const domain = createDomain('lang');

const $langType = $tourData.map(
  (state) => state.config?.language?.type ?? EditConfigLanguageType.cn
);

export const updateEditingLang = domain.event<EditConfigLanguageType | null>();
const $editingLangType = restore(updateEditingLang, null);

export const $isCn = combine(
  $langType,
  $editingLangType,
  $templateId,
  (langType, eType, templateId) => {
    let type = eType === null ? langType : eType;
    if (!getTemplateConfig(templateId)('language')) {
      type = EditConfigLanguageType.cn;
    }
    return (
      type === EditConfigLanguageType.cn ||
      (type === EditConfigLanguageType.system &&
        navigator.language.toLowerCase().includes('zh'))
    );
  }
);
